import React, { useState, useEffect } from 'react';
import {
  Typography,
  Grid,
  Button,
  Box,
} from '@mui/material';
import { useSelector } from 'react-redux';
import ClubProgressSlider from './ClubProgressSlider';
import BenefitCard from './BenefitCard';
import PerformanceBarChart from './PerformanceHistoryChart';
import ReusableComparisonTable from './ReusableComparisonTable';
import ReusableModal from '../../../MUI_custom_component/Modal/CustomModal';
import ModalList from '../../../MUI_custom_component/Modal/ModalList';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { InfoOutlined } from '@mui/icons-material';

const SocialSecurityBenefit = ({ benefits, selectedManufacturer, selectedCompanyEntity }) => {
    const [ TNCModal , setTNCModal ] = useState(false);
    const { period, club_progress_details, current_benefits_details, benefit_table_info, performance_history_info, tnc  } = benefits || {};
    const userData = useSelector(state => state.user?.userData);

    const benefit_club = club_progress_details?.slider_info?.min_club_info?.club_name || 
                        club_progress_details?.slider_info?.max_club_info?.club_name || 
                        club_progress_details?.title || 
                        'SSB';
    const gapInfo = benefits?.gap_info || {};
    
    useEffect(() => {
        if (current_benefits_details && selectedManufacturer) {
            const activeBenefits = current_benefits_details
                .filter(benefit => benefit.status === 'Active')
                .map(benefit => benefit.display_name);
            const inactiveBenefits = current_benefits_details
                .filter(benefit => benefit.status !== 'Active')
                .map(benefit => benefit.display_name);

                        trackAnalyticsEvent('MY_BENEFIT_CURRENT_POLICY_LOAD', {
                benefit_club: benefit_club,
                benefit_club_period: period,
                benefit_club_period_sales: current_benefits_details?.current_scheme_benefits,
                benefit_club_period_sales_uom: current_benefits_details?.benefits_uom,
                policy_id: current_benefits_details?.policy_id,
                period_end_date: current_benefits_details?.period_end_date,
                period_start_date: current_benefits_details?.period_start_date,
                manufacturer_id: userData?.manufacturer_id || selectedManufacturer
            });
        }
    }, [current_benefits_details, selectedManufacturer]);

    // Track performance history load event
    useEffect(() => {
        if (performance_history_info && selectedManufacturer) {
            trackAnalyticsEvent('MY_BENEFIT_PERFORMANCE_HISTORY_LOAD', {
                benefit_club: benefit_club,
                benefit_club_period: period,
                manufacturer_id: userData?.manufacturer_id || selectedManufacturer
            });
        }
    }, [performance_history_info, selectedManufacturer]);

    const handleTNCClick = () => {
        if (selectedManufacturer) {
                        trackAnalyticsEvent('MY_BENEFIT_TNC_BUTTON_CLICKED', {
                benefit_club: benefit_club,
                benefit_club_period: period,
                manufacturer_id: userData?.manufacturer_id || selectedManufacturer
            });
        }
        setTNCModal(true);
    };

    const handleTNCModalClose = () => {
        if (selectedManufacturer) {
            trackAnalyticsEvent('MY_BENEFIT_TNC_MODAL_CLOSE', {
                manufacturer_id: selectedManufacturer,
                close_method: 'close_button'
            });
        }
        setTNCModal(false);
    };

    // Track TNC modal load
    useEffect(() => {
        if (TNCModal && selectedManufacturer) {
            trackAnalyticsEvent('MY_BENEFIT_TNC_MODAL_LOAD', {
                manufacturer_id: selectedManufacturer
            });
        }
    }, [TNCModal, selectedManufacturer]);
    return (
      <>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3, lg: 3 }} mb={3}>
          <Grid item xs={12} sm={6} lg={6} mb={{ xs: 2, md: 0}}>
            <ClubProgressSlider period={period} progress={club_progress_details} spacing={true} insurance={true} />
          </Grid>
          
          <Grid item xs={12} sm={6} lg={6}>
            {benefits?.allocation_info && (
              <Grid item xs={12} sm={12} md={12}>
                <Box sx={{
                  border: '1px solid #995A0080',
                  background: "#fff",
                  borderRadius: 2,
                  mb: 2,
                  p: 2
                }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #D9D9D9', mb: 1, pb: 0.5  }}>
                    <Typography variant="labelD" mb={1} sx={{ color: benefits?.allocation_info?.completed_allocation?.type === 'success' ? '#008000' : '#CC0000', }}>{benefits?.allocation_info?.completed_allocation?.display_name}</Typography>
                    <Typography variant="labelD" mb={1} sx={{ color: benefits?.allocation_info?.completed_allocation?.type === 'success' ? '#008000' : '#CC0000', }}>{benefits?.allocation_info?.completed_allocation?.value}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <InfoOutlined sx={{ fontSize: '16px', mr: 0.5, color: '#333' }} />
                      <Typography variant="labelM" sx={{color: '#333' }}>{benefits?.allocation_info?.required_allocation?.display_name}</Typography>
                    </Box>
                    <Typography variant="labelM" sx={{ color: '#333' }}>{benefits?.allocation_info?.required_allocation?.value}</Typography>
                  </Box>
                </Box>
              </Grid>
            )}
            <Typography variant="h2" mb={1}>Current Policies</Typography>
            <Grid container spacing={{xs:1, md: 2}} sx={{ mb: 2}}>
              {current_benefits_details && current_benefits_details.map((benefit, idx) => (
                <Grid item xs={6} sm={6} md={6} key={idx}>
                  <BenefitCard benefit={benefit} selectedManufacturer={selectedManufacturer} selectedCompanyEntity={selectedCompanyEntity} />
                </Grid>
              ))}
            </Grid>

             <Typography variant="h2" mb={1}>Current Golden Age Plan</Typography>
              <Grid container spacing={{xs:1, md: 2}}>
                  <Grid item xs={12} sm={12} md={12}>
                    <BenefitCard benefit={gapInfo} selectedManufacturer={selectedManufacturer} selectedCompanyEntity={selectedCompanyEntity} />
                  </Grid>
              </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3, lg: 3 }}>
          <Grid item xs={12} sm={6} lg={6} sx={{ mb: { xs: 2, sm: 0 }}} >
            <ReusableComparisonTable
              title="Benefit Comparison"
              tableInfo={benefit_table_info}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={6} sx={{ mb: { xs: 2, sm: 0 }}} >
            {performance_history_info && (
              <PerformanceBarChart  
                title="Performance History"
                data={performance_history_info?.data}
                unit={performance_history_info?.unit}
              />
            )}
             <Button
                color='primary'
                variant='outlined'
                sx={{
                  width: { xs: '100%', sm: 'auto'},
                  marginTop: { xs: 2, md: 0 },
                  display: { xs: 'block', md: 'none' },
                }} 
                onClick={handleTNCClick}
              >
                Terms & Conditions
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} lg={6} sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Button
              color='primary'
              variant='outlined'
              sx={{
                width: { xs: '100%', sm: 'auto'},
                display: { xs: 'none', sm: 'block', textTransform: 'capitalize' },
              }} 
              onClick={handleTNCClick}
            >
              Terms & Conditions
            </Button>
          </Grid>
          
          <ReusableModal
            open={TNCModal}
            onClose={handleTNCModalClose}
            title="Terms & Conditions"
            subtitle="Benefits"
          >
            <ModalList list={tnc} />
          </ReusableModal>
        </Grid>
      </>
    );
};

export default SocialSecurityBenefit;
